import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://svoflgmjxwybpjkgnqga.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN2b2ZsZ21qeHd5YnBqa2ducWdhIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjA3MzM0NzUsImV4cCI6MjA3NjMwOTQ3NX0.glbNbTpeLYx4DWddIgL2bZU9_-kz4T6uZa62nClLU5w";
const supabase = createClient(supabaseUrl, supabaseKey);

export default supabase;
